
export const CodeTemplates = Object.freeze({
    "TRAVEL_ABROAD":"travel_abroad",
    "FIRST_DRIVER":"first_driver",
    "SECOND_DRIVER":"second_driver",
    "RENT":"rent",
    "ITV":"itv",
    "WORKSHOP_APPOINTMENT": "workshop_appointment",
    "DOCUMENTATION_REQUEST":"documentation",
    "FACTORY_PROCESS_VEHICLE_DELIVERY": "factory_process_vehicle_delivery",
    "FACTORY_PROCESS_CLAIMS": "factory_process_claims",
    "INFORMATION":"information",
    "TERMINATIONS":"terminations",
    "SUBSTITUTION_VEHICLE":"substitution_vehicle",
    "CLAIMS":"factory_process_claims",
    "DELIVERY":"factory_process_vehicle_delivery",
    "FACTORY_PROCESS_OTHER": "factory_process_other",
    "OVC" : 'ovc',
    "FAILED_ITV": "failed_itv",
    "ACCESORY_ASSEMBLY": "accesory_assembly",
    "FUEL_CARD": "fuel_card",
    "MARSH_ASSISTANCE": "marsh_assistance",
    "LETTER_QUERY": "letter_query",
    "RESIDENT_CARD_LETTER": "resident_card_letter"
    })

export const FactoryProcessCodeTemplates = Object.freeze({
    "FACTORY_PROCESS_VEHICLE_DELIVERY": "factory_process_vehicle_delivery",
    "FACTORY_PROCESS_CLAIMS": "factory_process_claims"
})

export const FactoryProcessTemplates = Object.freeze({
    "CREATE_CASE_WORKSHOP_APPOINTMENT": "create_case_factory_workshop_appointment",
    "CREATE_CASE_ITV_SUBSCRIPTION": "create_case_factory_station_subscription",
    "FACTORY_PROCESS_INCIDENCE": "factory_process_incidence",
    "FACTORY_PROCESS_TERM": "factory_process_term",
    "FACTORY_PROCESS_BODYWORK_CLAIM": "factory_process_bodywork_claim",
    "FACTORY_PROCESS_MAINTENANCE_CLAIM": "factory_process_maintenance_claim",
    "FACTORY_PROCESS_TIRES_CLAIM": "factory_process_tires_claim",
    "FACTORY_PROCESS_URGENT_CLAIM": "factory_process_urgent_claim"
})

export const TemplatesAvaliableWithNewCase = [
    CodeTemplates.WORKSHOP_APPOINTMENT,
    CodeTemplates.DOCUMENTATION_REQUEST, 
    CodeTemplates.FACTORY_PROCESS_VEHICLE_DELIVERY,
    CodeTemplates.FACTORY_PROCESS_CLAIMS,
    CodeTemplates.INFORMATION,
    CodeTemplates.TERMINATIONS,
    CodeTemplates.SUBSTITUTION_VEHICLE,
    CodeTemplates.OVC,
    CodeTemplates.FAILED_ITV,
    CodeTemplates.MARSH_ASSISTANCE
]

export const TemplatesAvaliableWithClosedCase = []

export const TemplatesAvaliableWithNoPlate = [
    CodeTemplates.TRAVEL_ABROAD,
    CodeTemplates.FIRST_DRIVER,
    CodeTemplates.SECOND_DRIVER,
    CodeTemplates.RENT,
    CodeTemplates.ITV
]